import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';

/**
 * /about-us.
 *
 * The copy is the legacy page's, word for word — this is a framework change, not a copy
 * change, as on TopMags and MagSpot.
 *
 * The heading is the legacy page's plain "About Us", which its template writes out
 * rather than building from `{company.companyname}`. Every brand's says that now --
 * MagSpot's used to read "About MagSpot.com" and no longer does.
 */
export default function AboutUs() {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'About Us' }]} />

      <PageHeading eyebrow="Customer Information">About Us</PageHeading>

      <div className="prose mt-6 flex flex-col gap-6">
        <ContentCard>
          <p>
            Since 2014, MagZoom.com has been one of the fastest growing, family run, magazine
            subscription sites. We pride ourselves on having a wide selection of your favorite
            subscriptions to provide the best prices and shipping directly to your mailbox. We
            guarantee satisfaction and believe in putting the customer first, taking care of
            employees and supporting our community. Our friendly staff is committed to helping you
            save money on all orders while making your experience as satisfactory as possible.
          </p>

          <p>
            All cover images and magazine trademarks on MagZoom.com are property of each respective
            publisher.
          </p>

          <p>Our office is located in downtown Philadelphia. Office visits are by appointment only.</p>
        </ContentCard>
      </div>
    </>
  );
}

AboutUs.layoutName = 'Layouts.Institutional';
